import FieldConfig from "../../../proto/field-config"
import FieldNumber from "../../../generic/number/number"
import ItemModelV2 from "../../../../model2/item2/item-model"
import Task from "../../../../model2/task/task"
import TasksViewManager from "../../../../gd-modules/tasks-view/core/manager"
import {LifecycleAction} from "../../../../gd/const/lifecycle"
import {ViewType} from "../../../../gd/const/views/view-type"
import GanttManager from "../../../../gd-modules/gantt-chart/manager/manager"
import FieldProto_updateView from "../../../proto/render/table/function/update-view"

export default class FieldTaskDurationWorkdays extends FieldNumber {

    constructor(config:FieldConfig) {
        super(config);

        this.icon               = 'i5-age'
        this.label              = 'Duration work days'

        this.isFilterAvailable  =   true

        this.fieldParams.tableCellOnValueChange = this.tableCellOnValueChange
    }

    canEdit(model:Task):boolean {
        return model.acl.canChangeDuration
    }

    tableCellOnValueChange = async (item: ItemModelV2, value: number, manager: TasksViewManager | GanttManager) => {
        switch (manager.module) {
            case ViewType.PROJECT_GANTT:
            case ViewType.PORTFOLIO_GANTT:
            case ViewType.CUSTOM_VIEW_GANTT:
                const ganttManager = manager as GanttManager
                ganttManager.updateFieldManager2.setWorkDuration(item.id, value)
                break

            default:
                item.task.durationWorkdays = value
                item.task.save()

                item.updateLastUpdateTime() // otherwise it wont re-render

                FieldProto_updateView(manager as TasksViewManager, this)
                break
        }
    }

}
